import { ActionFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isDefined } from '@hsp/utilities';

import { authenticationService } from 'services';
import { IUser, IUserProfile } from 'types/user';
import { s } from 'utilities/strings';

export const profileAction = (_: QueryClient) => {
  return async ({ request }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const profileRequest: Record<string, string> = {};

    formData.forEach((value, key) => (profileRequest[key] = value as string));

    try {
      let fn: null | ((data: IUserProfile) => Promise<IUser> | undefined) = null;

      if (process.env.REACT_APP_API_AUTH_FAKE === 'jwt') {
        fn = authenticationService.postJwtProfile;
      } else if (process.env.REACT_APP_API_AUTH_FAKE === 'fake') {
        fn = authenticationService.postFakeProfile;
      }

      if (isDefined(fn)) {
        const response = await fn.call(authenticationService, profileRequest as unknown as IUserProfile);

        if (!isDefined(response)) {
          throw new Error(s('Api.UnknownError'));
        }

        return response;
      }

      throw new Error(s('Api.UnknownError'));
    } catch (e) {
      return { error: e };
    }
  };
};
